import { render, staticRenderFns } from "./CustomerGroupCreateEditModal.vue?vue&type=template&id=2304b462&"
import script from "./CustomerGroupCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports